import script from "./SaddleSelectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaddleSelectionView.vue?vue&type=script&setup=true&lang=ts"

import "./SaddleSelectionView.vue?vue&type=style&index=0&id=597e2e2b&lang=scss"

const __exports__ = script;

export default __exports__